import React from 'react';

const variants: Record<string, string> = {
  profile: 'profile',
  shop: 'shop',
  listings: 'listings',
};

const BundleSellingPoint = ({ variant, description }: { variant: string; description: string }) => {
  const imageClassName = variants[variant] ? `image--${variants[variant]}` : 'image--shop';
  return (
    <div className="BundleSellingPoint-root">
      <div className="BundleSellingPoint-circle">
        <div className={`BundleSellingPoint-image BundleSellingPoint-${imageClassName}`} />
      </div>
      <p className="BundleSellingPoint-description">{description}</p>
    </div>
  );
};

export { variants };

export default BundleSellingPoint;
